import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Favourite(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.215 18.958l.001.001.123.11a1 1 0 001.33.003l.116-.104c2.596-2.314 4.668-4.162 6.103-5.884C20.313 11.374 21 9.914 21 8.395 21 5.945 19.046 4 16.5 4c-1.444 0-2.84.664-3.745 1.706l-.755.87-.755-.87A5.037 5.037 0 007.5 4C4.954 4 3 5.944 3 8.395c0 1.52.687 2.979 2.112 4.687 1.435 1.722 3.507 3.567 6.103 5.876zm-.665.747l.123.11a2 2 0 002.659.005l.118-.105.04-.035C18.616 15.109 22 12.094 22 8.395 22 5.374 19.58 3 16.5 3a6.046 6.046 0 00-3.78 1.354c-.26.212-.502.445-.72.696a5.778 5.778 0 00-.72-.696A6.046 6.046 0 007.5 3C4.42 3 2 5.374 2 8.395c0 3.705 3.394 6.724 8.537 11.299l.013.011z",
    clipRule: "evenodd"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Favourite);
export default ForwardRef;